import { render } from "./HeroPaymentStatus.vue?vue&type=template&id=2b7f6dd5&scoped=true"
import script from "./HeroPaymentStatus.vue?vue&type=script&lang=js"
export * from "./HeroPaymentStatus.vue?vue&type=script&lang=js"

import "./HeroPaymentStatus.vue?vue&type=style&index=0&id=2b7f6dd5&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7f6dd5"]])

export default __exports__